import { render, staticRenderFns } from "./SQuesThirty.vue?vue&type=template&id=1500978f&"
import script from "./SQuesThirty.vue?vue&type=script&lang=js&"
export * from "./SQuesThirty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports